import { FormEvent, useState } from "react";
import { useEmailService } from "../../libs/email/email-check.hook";
import { ErrorCodes } from "../../libs/error-handling/errors";
import { RegistrationSteps } from "../../libs/registration/registration-steps";
import { useRegistration } from "../../libs/registration/registration.hook";
import { AppForm } from "../form/styles/app-form";
import { BackButton } from "../form/styles/back-button";
import { CtaButton } from "../form/styles/cta-button";
import { SingleInput } from "../form/styles/single-input";
import { SmallButton } from "../form/styles/small-button";
import { LoadingComp } from "../loading/loading.comp";

export const PinComp = (props: {
  setStep: (step: RegistrationSteps) => void;
}) => {
  const [pin, setPin] = useState("");
  const { fetching, checkPin, resetPin } = useEmailService();
  const { registrationInfo, setRegistrationInfo } = useRegistration();

  const onSubmit = async (evt: FormEvent) => {
    evt.preventDefault();

    const { event, ...resp } = await checkPin(
      registrationInfo?.email || "",
      pin
    );
    if (resp.errorCode === ErrorCodes.ClientNotFound) {
      alert("Client not found");
    } else if (resp.errorCode === ErrorCodes.InvalidPin) {
      alert("Invalid PIN");
    } else {
      setRegistrationInfo({
        ...resp,
        pin: pin,
      });
      props.setStep(RegistrationSteps.ContactInfo);
    }
  };

  const onBack = (event: FormEvent) => {
    event.preventDefault();
    props.setStep(RegistrationSteps.Email);
  };

  const onReset = async (event: FormEvent) => {
    event.preventDefault();
    await resetPin(registrationInfo?.email || "");
  };

  return (
    <AppForm onSubmit={onSubmit}>
      <SingleInput
        onChange={(event: any) => setPin(event.target.value)}
        value={pin}
        placeholder="Your PIN"
      />
      <div>
        <BackButton onClick={onBack}>Back</BackButton>
        <CtaButton>Next</CtaButton>
      </div>
      <p>
        Forgot PIN? <SmallButton onClick={onReset}>Reset</SmallButton>
      </p>
      {fetching && <LoadingComp />}
    </AppForm>
  );
};
